import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface CpuSettingsIconProps {
  color?: string;
}

export function CpuSettingsIcon({ color }: CpuSettingsIconProps) {
  const currentColor = color || '#FFFFFF';

  return (
    <Svg width="40" height="40" viewBox="0 0 68 68" fill="none">
      <Path
        d="M56.6667 27.2C56.6667 15.8666 52.1333 11.3333 40.8 11.3333H27.2C15.8667 11.3333 11.3333 15.8666 11.3333 27.2V40.8C11.3333 52.1333 15.8667 56.6666 27.2 56.6666"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M46.325 22.6666C44.7667 20.6833 42.16 19.8333 38.25 19.8333H29.75C22.6667 19.8333 19.8333 22.6666 19.8333 29.75V38.25C19.8333 42.16 20.6833 44.7666 22.6383 46.325"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M22.695 11.3334V5.66669"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M34 11.3334V5.66669"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M45.3333 11.3334V5.66669"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M56.6667 22.6667H62.3333"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M22.695 56.6667V62.3334"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M5.66666 22.6667H11.3333"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M5.66666 34H11.3333"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M5.66666 45.3333H11.3333"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M47.345 52.6717C49.833 52.6717 51.85 50.6547 51.85 48.1667C51.85 45.6786 49.833 43.6617 47.345 43.6617C44.857 43.6617 42.84 45.6786 42.84 48.1667C42.84 50.6547 44.857 52.6717 47.345 52.6717Z"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M32.3283 49.47V46.835C32.3283 45.2767 33.6033 44.0017 35.1617 44.0017C37.8817 44.0017 38.9867 42.075 37.6267 39.7234C36.8333 38.3634 37.315 36.6067 38.675 35.8417L41.2533 34.34C42.4433 33.6317 43.9733 34.0567 44.6817 35.2467L44.8517 35.53C46.2117 37.8817 48.4217 37.8817 49.7817 35.53L49.9517 35.2467C50.66 34.0567 52.19 33.66 53.38 34.34L55.9583 35.8417C57.3183 36.635 57.8 38.3634 57.0067 39.7234C55.6467 42.075 56.7517 44.0017 59.4717 44.0017C61.03 44.0017 62.305 45.2767 62.305 46.835V49.47C62.305 51.0283 61.03 52.3033 59.4717 52.3033C56.7517 52.3033 55.6467 54.23 57.0067 56.5817C57.8 57.9417 57.3183 59.6984 55.9583 60.4634L53.38 61.965C52.19 62.6734 50.66 62.2484 49.9517 61.0584L49.7817 60.775C48.4217 58.4234 46.2117 58.4234 44.8517 60.775L44.6817 61.0584C43.9733 62.2484 42.4433 62.645 41.2533 61.965L38.675 60.4634C37.315 59.67 36.8333 57.9417 37.6267 56.5817C38.9867 54.23 37.8817 52.3033 35.1617 52.3033C33.6033 52.3317 32.3283 51.0567 32.3283 49.47Z"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

interface RankingIconProps {
  color?: string;
}

export function RankingIcon({ color }: RankingIconProps) {
  const currentColor = color || '#FFFFFF';

  return (
    <Svg width="40" height="40" viewBox="0 0 68 68" fill="none">
      <Path
        d="M24.565 39.6666H11.3333C8.21666 39.6666 5.66666 42.2166 5.66666 45.3333V62.3333H24.565V39.6666Z"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M37.7684 28.3334H30.2033C27.0867 28.3334 24.5367 30.8834 24.5367 34V62.3334H43.435V34C43.435 30.8834 40.9134 28.3334 37.7684 28.3334Z"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M56.6667 48.1666H43.435V62.3333H62.3333V53.8333C62.3333 50.7166 59.7833 48.1666 56.6667 48.1666Z"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M35.4733 5.86499L36.975 8.86831C37.1733 9.29331 37.7117 9.68997 38.165 9.74664L40.885 10.2C42.6133 10.4833 43.0383 11.7583 41.7917 12.9766L39.6667 15.1016C39.2983 15.4699 39.1 16.15 39.2133 16.6316L39.8083 19.2383C40.29 21.3067 39.185 22.1 37.3717 21.0233L34.8217 19.5217C34.3683 19.2383 33.6033 19.2383 33.15 19.5217L30.6 21.0233C28.7867 22.1 27.6817 21.3067 28.1633 19.2383L28.7583 16.6316C28.8717 16.15 28.6733 15.4416 28.305 15.1016L26.2083 13.005C24.9617 11.7583 25.3583 10.5116 27.115 10.2283L29.835 9.775C30.2883 9.69 30.8267 9.29334 31.025 8.89667L32.5267 5.89326C33.3483 4.24993 34.6517 4.24999 35.4733 5.86499Z"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

